import React, { Fragment, useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CustomInput,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Table,
} from "reactstrap";
import Loader from "react-loaders";
import { api } from "../../_services/api.service";
import { userService } from "../../_services/user.service";
import PageTitle from "../../Layout/AppMain/PageTitle";
import AvForm from "availity-reactstrap-validation/lib/AvForm";
import AvField from "availity-reactstrap-validation/lib/AvField";
import GeneralGrid from "../../Components/GeneralGrid";
import { toast } from "react-toastify";
import MetricSettings from "../Metric/MetricSettings";
import CriteriaSettings from "../Criteria/CriteriaSettings";
import AlternativeSettings from "../Alternative/AlternativeSettings";
import AlternativePreviewModal from "../Alternative/AlternativePreviewModal";
import { currencyFormatter } from "../../_services/currencyFormatter";
import Switch from "react-switch";
import swal from "sweetalert";
import download from "downloadjs";
import CardHeader from "reactstrap/lib/CardHeader";
import exceptionHandler from "../../_helpers/exceptionHandler";
import PhasesCard from "../Phase/PhasesCard";
import MilestonesCard from "../Milestone/MilestonesCard";
import FieldsCard from "../Milestone/FieldsCard";
import { AppHelper } from "../../_helpers/appHelper";
import ImageUploadField from "../../Components/ImageUploadField";
import colors from "../../_helpers/colors";

const DecisionTemplateSettings = (props) => {
  const currentUser = userService.getLoggedInUser();
  const partnerId = parseInt(props.match.params.partnerId);
  let partnerScenarioId = parseInt(props.match.params.partnerScenarioId);
  const hiddenFileInput = React.useRef(null);
  let [userId, setUserId] = useState(-1);
  let [scenario, setScenario] = useState({
    partnerScenarioID: -1,
    partnerScenarioName: "",
    publicScenario: false,
    inactive: false,
    costName: "",
    description: "",
    useAltAPI: false,
    useIncludedAlternatives: false,
    altAPIKey: "",
    useCost: true,
    ahpOnly: false,
    usePhases: false,
    parentID: 0,
    pwcMethod: "",
    compareAdjective: "More Important",
  });
  let [isLoading, setIsLoading] = useState(false);
  let [isAddUserModalVisible, setIsAddUserModalVisible] = useState(false);
  let [objectives, setObjectives] = useState([]);
  let [metrics, setMetrics] = useState([]);
  let [alternatives, setAlternatives] = useState([]);
  let [phases, setPhases] = useState([]);
  let [milestones, setMilestones] = useState([]);
  let [activeTab, setActiveTab] = useState(1);

  let [selectedPartnerMetricId, setSelectedPartnerMetricId] = useState(-1);
  let [selectedPartnerObjectiveId, setSelectedPartnerObjectiveId] =
    useState(-1);
  let [selectedPartnerAlternativeId, setSelectedPartnerAlternativeId] =
    useState(-1);
  let [isMetricModalOpen, setIsMetricModalOpen] = useState(false);
  let [isCritModalOpen, setIsCritModalOpen] = useState(false);
  let [isAltModalOpen, setIsAltModalOpen] = useState(false);
  let [isAltPreviewModalOpen, setIsAltPreviewModalOpen] = useState(false);
  const [isTemplateSetupReportLoading, setIsTemplateSetupReportLoading] =
    useState(false);

  let [user, setUser] = useState({
    userID: -1,
    firstName: "",
    lastName: "",
    email: "",
    allTemplates: false,
    partnerID: partnerId,
    partnerRoleID: 2,
    templateCategoryID: 0,
  });
  let [partnerObjectives, setPartnerObjectives] = useState([]);
  let [partnerScenarios, setPartnerScenarios] = useState([]);
  let [isActionSubmitting, setIsActionSubmitting] = useState(false);
  let [templateCategories, setTemplateCategories] = useState([]);

  const successToastOpts = {
    autoClose: 3000,
    type: toast.TYPE.SUCCESS,
    hideProgressBar: false,
  };

  useEffect(() => {
    loadScenario(partnerScenarioId);
    loadPartnerObjectives();
  }, []);

  // load phases when needed
  useEffect(() => {
    if (phases && phases.length > 0) return;

    loadPhasesAndMilestones();
  }, [scenario]);

  const loadMilestones = () => {
    const phaseIDs = phases.map((x) => x.phaseID);
    api.getMilestonesByPhases(phaseIDs).then((data) => {
      if (data) setMilestones(data);
    });
  };

  const loadPartnerObjectives = () => {
    api.getPartnerObjectives(partnerId).then((o) => {
      setPartnerObjectives(o);
    });
  };

  const loadPhasesAndMilestones = () => {
    if (scenario.usePhases && scenario.partnerScenarioID > 0) {
      api
        .getPhasesByPartnerScenarioID(scenario.partnerScenarioID)
        .then((data) => {
          if (data) setPhases(data);
          return data ? data.map((x) => x.phaseID) : [];
        })
        .then((phaseIDs) => {
          console.log(phaseIDs);
          api.getMilestonesByPhases(phaseIDs).then((data) => {
            if (data) setMilestones(data);
          });
        })
        .catch(exceptionHandler);
    }
  };

  const loadPhases = () => {
    api
      .getPhasesByPartnerScenarioID(scenario.partnerScenarioID)
      .then((data) => {
        if (data) setPhases(data);
      })
      .catch(exceptionHandler);
  };

  const loadScenario = (psId) => {
    if (psId > 0) {
      setIsLoading(true);
      api.getPartnerScenarioById(psId).then((data) => {
        setScenario(data);
        loadData(data.useIncludedAlternatives);
        setIsLoading(false);
      });
    }

    api.getTemplateCategories().then((tc) => {
      setTemplateCategories(tc);
    });
  };

  const loadData = (includeAlternatives) => {
    loadObjectives();
    loadMetrics();
    if (includeAlternatives) {
      loadAlternatives();
    }
  };

  const loadMetrics = () => {
    api.getPartnerMetricsByPartnerScenario(partnerScenarioId).then((data) => {
      setMetrics(data);
    });
  };

  const loadObjectives = () => {
    api
      .getPartnerObjectivesByPartnerScenarioId(partnerScenarioId)
      .then((data) => {
        setObjectives(data);
      });
  };

  const loadAlternatives = () => {
    api
      .getPartnerAlternativesByPartnerScenarioId(partnerScenarioId)
      .then((data) => {
        setAlternatives(data);
      });
  };

  // Save Template
  const handleSubmit = (e, errors, values) => {
    if (errors.length == 0) {
      if (scenario.partnerScenarioID > 0) {
        api.updatePartnerScenario(0, scenario).then((data) => {
          toast("PartnerScenario saved successfuly", successToastOpts);
        });
      } else {
        let scenarioCopy = { ...scenario };
        scenarioCopy.partnerID = partnerId;

        api.createPartnerScenario(0, scenarioCopy).then((id) => {
          toast("PartnerScenario saved successfuly", successToastOpts);

          props.history.replace({
            pathname: `/decisiontemplate/${partnerId}/${id}`,
          });
          partnerScenarioId = id;
          loadScenario(id);
        });
      }
    }
  };

  const removeTemplate = () => {
    swal({
      text: "Removing a template will Permanently Delete it from the System.  The decisions made from this template will remain.  If you just want to make the template unavailable to users, but want to keep the information, mark it Inactive instead",
      icon: "warning",
      buttons: {
        ok: "Delete Template",
        cancel: "Cancel",
      },
      dangerMode: true,
    }).then((val) => {
      if (val) {
        api.deletePartnerScenario(0, scenario).then((data) => {
          props.history.push({
            pathname: `/decisiontemplates/${partnerId}`,
          });
        });
      }
    });
  };

  const testAPI = async () => {
    let tpl = scenario.altAPISearchTemplate;
    let searchField = scenario.altAPINameField;
    const key = scenario.altAPIKey;
    let url = tpl.replace("[KEY]", key);
    url = url.replace(`${searchField}=[SEARCHSTRING]&`, "");
    url = url.replace(`&${searchField}=[SEARCHSTRING]`, "");

    if (scenario.altAPIKeyType === "auth header") {
      let reqOptions = {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      };
      reqOptions.headers[scenario.altAPIKeyName] = key;

      var response = await fetch(url, reqOptions);
      var body = await response.json();
      swal({
        text: JSON.stringify(body),
        icon: "info",
        className: "swal-wide",
        buttons: {
          ok: "Ok",
        },
        dangerMode: false,
      });
    } else {
      window.open(url, "_blank");
    }
  };

  const goToAlternative = (partnerAlternativeId) => {
    setSelectedPartnerAlternativeId(partnerAlternativeId);
    toggleAlternativeModal();
  };

  const previewAlternative = (partnerAlternativeId) => {
    setSelectedPartnerAlternativeId(partnerAlternativeId);
    toggleAltPreviewModal();
  };

  const toggleAlternativeModal = () => {
    setIsAltModalOpen(!isAltModalOpen);
  };

  const goToMetric = (partnerMetricId) => {
    setSelectedPartnerMetricId(partnerMetricId);
    toggleMetricModal();
  };

  const toggleMetricModal = () => {
    setIsMetricModalOpen(!isMetricModalOpen);
  };

  const goToCriteria = (partnerObjectiveId) => {
    //setIsCritModalOpen(true);
    setSelectedPartnerObjectiveId(partnerObjectiveId);
    toggleCriteriaModal();
  };

  const toggleCriteriaModal = () => {
    setIsCritModalOpen(!isCritModalOpen);
  };

  const toggleAddUserModal = () => {
    setIsAddUserModalVisible(!isAddUserModalVisible);
  };

  const toggleAltPreviewModal = () => {
    setIsAltPreviewModalOpen(!isAltPreviewModalOpen);
  };

  const handleUserSubmit = (e, errors, values) => {
    if (errors.length == 0) {
      if (user.userID > 0) {
        api.updatePartnerUser(currentUser.userId, user).then((id) => {
          toast("User updated successfuly", successToastOpts);
        });
      } else {
        api.createPartnerUser(currentUser.userId, user).then((id) => {
          toast("User created successfuly", successToastOpts);

          api.updatePartnerScenarioUser(id, partnerScenarioId, true);
          api.getPartnerUserByID(id, partnerId).then((u) => {
            setUser(u);
          });
          setUserId(id);
          loadPartnerScenarios(id);
        });
      }
    }
  };

  const loadPartnerScenarios = (userId) => {
    api.getPartnerScenariosByUserId(userId).then((ups) => {
      api.getPartnerScenariosByPartnerId(partnerId).then((data) => {
        setPartnerScenarios(
          data.map((x) => {
            if (
              ups.find((p) => p.partnerScenarioID == x.partnerScenarioID) !==
              undefined
            ) {
              x.isSelected = true;
            } else {
              x.isSelected = false;
            }
            return x;
          })
        );
      });
    });
  };

  const changePartnerScenarioSelection = (partnerScenario) => {
    if (!isActionSubmitting) {
      isActionSubmitting = true;

      let ds = [...partnerScenarios];
      let item = ds.find(
        (d) => d.partnerScenarioID == partnerScenario.partnerScenarioID
      );
      item.isSelected = !item.isSelected;
      let index = ds.findIndex(
        (d) => d.partnerScenarioID == partnerScenario.partnerScenarioID
      );
      ds[index] = item;
      setPartnerScenarios(ds);

      api
        .updatePartnerScenarioUser(
          userId,
          partnerScenario.partnerScenarioID,
          item.isSelected
        )
        .then(
          (data) => {
            setIsActionSubmitting(false);
          },
          (error) => {
            setIsActionSubmitting(false);
          }
        );
    }
  };

  const downloadPartnerAlternativeExcelTemplate = (e) => {
    e && e.preventDefault();
    api.getPartnerAlternativesExcelTemplate(partnerScenarioId).then((blob) => {
      download(blob, "PartnerAlternativeTemplate.xlsx");
    });
  };

  const handleUploadAlternativesClick = (event) => {
    hiddenFileInput.current.click();
  };

  const handleImageInputChange = (event) => {
    const fileUploaded = event.target.files[0];
    AppHelper.uploadImage(fileUploaded).then((url) => {
      setScenario({ ...scenario, icon: url });
    });
  };

  const handleInputFileChange = (event) => {
    const fileUploaded = event.target.files[0];
    event.target.value = "";

    api
      .uploadAlternatives(currentUser.userId, partnerScenarioId, fileUploaded)
      .then(
        (data) => {
          let infoMessage = "";
          if (data) {
            if (data.alternativeErrors && data.alternativeErrors.length > 0) {
              data.alternativeErrors.forEach((altError) => {
                infoMessage += altError + " ";
              });
            }

            if (data.metricErrors && data.metricErrors.length > 0) {
              data.metricErrors.forEach((metricError) => {
                infoMessage += metricError + " ";
              });
            }
          }
          if (infoMessage !== "") {
            swal({
              text: infoMessage,
              icon: "warning",
              buttons: {
                ok: "Ok",
              },
              dangerMode: true,
            });
          }
          loadAlternatives();
        },
        (err) => {
          toast(`Could not upload file, ${err}`, {
            autoClose: 3000,
            type: toast.TYPE.ERROR,
            hideProgressBar: false,
          });
        }
      );
  };

  const objectiveColumns = [
    {
      dataField: "partnerObjectiveName",
      text: "Name",
      sort: true,
      headerStyle: () => {
        return { width: "20%" };
      },
      formatter: (cellContent, row) => {
        return (
          <a
            key={row.partnerObjectiveID}
            href="#"
            onClick={(e) => {
              e.preventDefault();
              goToCriteria(row.partnerObjectiveID);
            }}
          >
            {cellContent}
          </a>
        );
      },
    },
    {
      dataField: "description",
      text: "Description",
      sort: true,
      headerStyle: () => {
        return { width: "40%" };
      },
    },
    // {
    //   dataField: "partnerMetricName",
    //   text: "Data item",
    //   sort: true,
    //   headerStyle: () => {
    //     return { width: "20%" };
    //   },
    // },
    {
      dataField: "mustHave",
      text: "Must Use",
      sort: true,
      headerStyle: () => {
        return { width: "10%" };
      },
      formatter: (cellContent, row) => {
        return (
          <CustomInput
            readOnly={true}
            type="checkbox"
            id={`mustObj-${row.partnerObjectiveID}`}
            checked={row.mustHave}
          />
        );
      },
    },
    {
      dataField: "inactive",
      text: "Active",
      sort: true,
      headerStyle: () => {
        return { width: "10%" };
      },
      formatter: (cellContent, row) => {
        return (
          <CustomInput
            readOnly={true}
            type="checkbox"
            id={`inactiveObj-${row.partnerObjectiveID}`}
            checked={!row.inactive}
          />
        );
      },
    },
  ];

  const metricColumns = [
    {
      dataField: "partnerMetricName",
      text: "Data Item Name",
      sort: true,
      headerStyle: () => {
        return { width: "60%" };
      },
      formatter: (cellContent, row) => {
        return (
          <a
            key={row.partnerMetricID}
            href="#"
            onClick={(e) => {
              e.preventDefault();
              goToMetric(row.partnerMetricID);
            }}
          >
            {cellContent}
          </a>
        );
      },
    },
    {
      dataField: "partnerMetricType",
      text: "Data Type",
      sort: true,
      headerStyle: () => {
        return { width: "40%" };
      },
    },
  ];

  const alternativeColumns = [
    {
      dataField: "partnerAlternativeName",
      text: "Name",
      sort: true,
      headerStyle: () => {
        return { width: "20%" };
      },
      formatter: (cellContent, row) => {
        return (
          <a
            key={row.partnerAlternativeID}
            href="#"
            onClick={(e) => {
              e.preventDefault();
              goToAlternative(row.partnerAlternativeID);
            }}
          >
            {cellContent}
          </a>
        );
      },
    },
    {
      dataField: "description",
      text: "Description",
      sort: true,
      headerStyle: () => {
        return { width: "30%" };
      },
    },
    {
      dataField: "cost",
      text: "Price",
      sort: true,
      headerStyle: () => {
        return { width: "10%" };
      },
      formatter: (cellContent, row) => {
        return currencyFormatter("$", cellContent, false);
      },
    },
    {
      dataField: "mustHave",
      text: "Must Use",
      sort: true,
      headerStyle: () => {
        return { width: "10%" };
      },
      formatter: (cellContent, row) => {
        return (
          <CustomInput
            readOnly={true}
            type="checkbox"
            id={`mustAlt-${row.partnerAlternativeID}`}
            checked={row.mustHave}
          />
        );
      },
    },
    {
      text: "Action Link",
      sort: false,
      headerStyle: () => {
        return { width: "20%" };
      },
      formatter: (cellContent, row) => {
        return (
          <a
            key={row.partnerAlternativeID}
            href="#"
            onClick={(e) => {
              e.preventDefault();
              previewAlternative(row.partnerAlternativeID);
            }}
          >
            {"Preview"}
          </a>
        );
      },
    },
  ];

  const goToResults = () => {
    props.history.push({
      pathname: `/decisiontemplateresults/${partnerId}/${partnerScenarioId}`,
    });
  };

  const showApiTab =
    scenario !== undefined && scenario !== null && scenario.useAltAPI;
  const showPhasesTab =
    scenario !== undefined && scenario !== null && scenario.usePhases;
  const tabWidth =
    showApiTab && showPhasesTab
      ? "33%"
      : showApiTab || showPhasesTab
      ? "50%"
      : "100%";

  const getTemplateSetupReport = () => {
    setIsTemplateSetupReportLoading(true);

    api.getScenarioReportQueryParam(currentUser.userId).then(
      (guid) => {
        setIsTemplateSetupReportLoading(false);
        let url = api.getTemplateSetupReportUrl(
          currentUser.userId,
          partnerScenarioId,
          guid
        );
        var win = window.open(url, "_blank");
        win.focus();
      },
      (err) => setIsTemplateSetupReportLoading(false)
    );
  };

  return (
    <Fragment>
      {scenario && (
        <PageTitle
          icon="far fa-list-alt"
          style={{ paddingLeft: "0px" }}
          heading={`${scenario.partnerScenarioName}`}
        />
      )}
      {scenario &&
        partnerScenarioId !== -1 && ( // do not show this button on new templates
          <Button color="primary" size="lg" onClick={goToResults}>
            {"<"} Dashboard
          </Button>
        )}
      {isLoading && <Loader style={{}} type="ball-pulse" active />}
      {!isLoading && (
        <Row style={{ marginTop: "30px" }}>
          <Col md="12">
            <Card className="main-card mb-3">
              <CardBody>
                <AvForm onSubmit={handleSubmit}>
                  <Row>
                    <Col md="6">
                      <AvField
                        name="partnerScenarioName"
                        label="Decision Template Name*"
                        value={scenario.partnerScenarioName}
                        onChange={(e) =>
                          setScenario({
                            ...scenario,
                            partnerScenarioName: e.target.value,
                          })
                        }
                        placeholder="Enter..."
                        required
                      />
                      {templateCategories.length > 0 && (
                        <div className="form-group">
                          <label>Template Category</label>
                          <CustomInput
                            type="select"
                            id="tc"
                            name="templatecat"
                            className="form-control"
                            onChange={(e) =>
                              setScenario({
                                ...scenario,
                                templateCategoryID: e.target.value,
                              })
                            }
                            value={scenario.templateCategoryID}
                          >
                            {templateCategories.map((x) => (
                              <option
                                key={x.templateCategoryID}
                                value={x.templateCategoryID}
                              >
                                {x.templateCategoryName}
                              </option>
                            ))}
                          </CustomInput>
                        </div>
                      )}

                      <AvField
                        name="description"
                        label="Description"
                        value={scenario.description}
                        type="textarea"
                        style={{ height: "100px" }}
                        onChange={(e) =>
                          setScenario({
                            ...scenario,
                            description: e.target.value,
                          })
                        }
                        placeholder="Enter..."
                        //required
                      />

                      <AvField
                        name="comparePrompt"
                        label="Comparison Prompt"
                        value={scenario.comparePrompt}
                        onChange={(e) =>
                          setScenario({
                            ...scenario,
                            comparePrompt: e.target.value,
                          })
                        }
                        placeholder="Enter..."
                      />

                      <AvField
                        name="compareAdjective"
                        label="Comparison Adjective"
                        value={scenario.compareAdjective}
                        onChange={(e) =>
                          setScenario({
                            ...scenario,
                            compareAdjective: e.target.value,
                          })
                        }
                        placeholder="Enter..."
                      />

                      <AvField
                        name="costName"
                        label="Cost Description"
                        value={scenario.costName}
                        onChange={(e) =>
                          setScenario({ ...scenario, costName: e.target.value })
                        }
                        placeholder="Enter..."
                      />

                      <AvField
                        name="contributedText"
                        label="Contribution Information"
                        value={scenario.contributedText}
                        onChange={(e) =>
                          setScenario({
                            ...scenario,
                            contributedText: e.target.value,
                          })
                        }
                        placeholder="Enter..."
                      />

                      <AvField
                        name="alternativeName"
                        label="Alternative Name"
                        value={scenario.alternativeName}
                        onChange={(e) =>
                          setScenario({
                            ...scenario,
                            alternativeName: e.target.value,
                          })
                        }
                        placeholder="Enter..."
                      />

                      <AvField
                        name="alternativeNamePlural"
                        label="Plural Alternative Name"
                        value={scenario.alternativeNamePlural}
                        onChange={(e) =>
                          setScenario({
                            ...scenario,
                            alternativeNamePlural: e.target.value,
                          })
                        }
                        placeholder="Enter..."
                      />

                      <ImageUploadField
                        label={"Alternative Icon"}
                        imageUri={scenario.icon}
                        handleImageInputChange={handleImageInputChange}
                      />
                    </Col>
                    <Col md="6">
                      <Row>
                        <AvField
                          name="xpType"
                          label="Progress Type"
                          value={scenario.xpType}
                          onChange={(e) =>
                            setScenario({ ...scenario, xpType: e.target.value })
                          }
                          placeholder="Enter... (ie. XP, Percent etc.)"
                        />
                      </Row>
                      <Row>
                        <div className="form-group">
                          <label>Phase Screen Type</label>
                          <CustomInput
                            type="select"
                            id="phaseScreenType"
                            name="phaseScreenType"
                            className="form-control"
                            onChange={(e) =>
                              setScenario({
                                ...scenario,
                                phaseScreenType: e.target.value,
                              })
                            }
                            value={scenario.phaseScreenType}
                          >
                            {["Journey", "List"].map((x) => (
                              <option key={x} value={x}>
                                {x}
                              </option>
                            ))}
                          </CustomInput>
                        </div>
                      </Row>
                      {currentUser.roleId == 110 && (
                        <Row className="pt-3">
                          <br />

                          <Switch
                            checked={scenario.publicScenario}
                            onChange={(e) =>
                              setScenario({
                                ...scenario,
                                publicScenario: !scenario.publicScenario,
                              })
                            }
                            className="mr-2 mb-2"
                            height={20}
                            width={40}
                          />

                          <label>
                            {scenario.publicScenario
                              ? "This template is public"
                              : "This template is private"}
                          </label>
                        </Row>
                      )}

                      {currentUser.roleId != 110 && (
                        <label>
                          {scenario.publicScenario
                            ? "This template is public"
                            : "This template is private"}
                        </label>
                      )}

                      {!scenario.ahpOnly && (
                        <Row className="pt-3">
                          <br />

                          <Switch
                            checked={scenario.useIncludedAlternatives}
                            onChange={(e) => {
                              setScenario({
                                ...scenario,
                                useIncludedAlternatives:
                                  !scenario.useIncludedAlternatives,
                                useAltAPI: false,
                              });

                              if (!scenario.useIncludedAlternatives)
                                loadAlternatives();
                            }}
                            className="mr-2 mb-2"
                            height={20}
                            width={40}
                          />

                          <label>
                            {scenario.useIncludedAlternatives
                              ? "This template includes alternatives"
                              : "This template does not include alternatives"}
                          </label>
                        </Row>
                      )}

                      {!scenario.ahpOnly && (
                        <Row className="pt-3">
                          <br />

                          <Switch
                            checked={scenario.useAltAPI}
                            onChange={(e) => {
                              setScenario({
                                ...scenario,
                                useAltAPI: !scenario.useAltAPI,
                                useIncludedAlternatives: false,
                              });
                            }}
                            className="mr-2 mb-2"
                            height={20}
                            width={40}
                          />

                          <label>{"Use External API for Alternatives"}</label>
                        </Row>
                      )}

                      <Row className="pt-3">
                        <br />

                        <Switch
                          checked={!scenario.lockObjectives}
                          onChange={(e) =>
                            setScenario({
                              ...scenario,
                              lockObjectives: !scenario.lockObjectives,
                            })
                          }
                          className="mr-2 mb-2"
                          height={20}
                          width={40}
                        />

                        <label>
                          {!scenario.lockObjectives
                            ? `Allow users to create and remove ${
                                scenario.ahpOnly ? "alternatives" : "criteria"
                              }`
                            : `Lock ${
                                scenario.ahpOnly ? "alternatives" : "criteria"
                              } - users cannot add or remove the ones in the template`}
                        </label>
                      </Row>

                      {scenario.useIncludedAlternatives &&
                        !scenario.ahpOnly && (
                          <Row className="pt-3">
                            <br />

                            <Switch
                              checked={!scenario.lockAlternatives}
                              onChange={(e) =>
                                setScenario({
                                  ...scenario,
                                  lockAlternatives: !scenario.lockAlternatives,
                                })
                              }
                              className="mr-2 mb-2"
                              height={20}
                              width={40}
                            />

                            <label>
                              {!scenario.lockAlternatives
                                ? "Allow users to create and remove alternatives"
                                : "Lock alternatives - users cannot add or remove the ones in the template"}
                            </label>
                          </Row>
                        )}

                      <Row className="pt-3">
                        <br />

                        <Switch
                          checked={!scenario.lockInvites}
                          onChange={(e) =>
                            setScenario({
                              ...scenario,
                              lockInvites: !scenario.lockInvites,
                            })
                          }
                          className="mr-2 mb-2"
                          height={20}
                          width={40}
                        />

                        <label>
                          {!scenario.lockInvites
                            ? "Allow users to invite other participants"
                            : "Lock participants - users cannot invite other participants"}
                        </label>
                      </Row>

                      {currentUser.roleId == 110 && (
                        <Row className="pt-3">
                          <br />

                          <Switch
                            checked={!scenario.inactive}
                            onChange={(e) =>
                              setScenario({
                                ...scenario,
                                inactive: !scenario.inactive,
                              })
                            }
                            className="mr-2 mb-2"
                            height={20}
                            width={40}
                          />

                          <label>
                            {scenario.inactive
                              ? "This template is inactive"
                              : "This template is active"}
                          </label>
                        </Row>
                      )}
                      <Row className="pt-3">
                        <br />

                        <Switch
                          checked={scenario.useCost}
                          onChange={(e) =>
                            setScenario({
                              ...scenario,
                              useCost: !scenario.useCost,
                            })
                          }
                          className="mr-2 mb-2"
                          height={20}
                          width={40}
                        />

                        <label>
                          {scenario.useCost
                            ? "Allow cost as an independend variable"
                            : "Do not allow cost as an independend variable"}
                        </label>
                      </Row>
                      <Row className="pt-3">
                        <br />

                        <Switch
                          checked={scenario.ahpOnly}
                          onChange={(e) =>
                            setScenario({
                              ...scenario,
                              ahpOnly: !scenario.ahpOnly,
                              useAltAPI: false,
                              useIncludedAlternatives: false,
                            })
                          }
                          className="mr-2 mb-2"
                          height={20}
                          width={40}
                        />

                        <label>
                          {scenario.ahpOnly
                            ? "Comparative prioritization only"
                            : "Normal criteria / alternative prioritization"}
                        </label>
                      </Row>

                      <Row className="pt-3">
                        <br />
                        <Switch
                          checked={scenario.usePhases}
                          onChange={(e) => {
                            setScenario({
                              ...scenario,
                              usePhases: !scenario.usePhases,
                            });
                          }}
                          className="mr-2 mb-2"
                          height={20}
                          width={40}
                        />

                        <label>
                          {scenario.usePhases
                            ? "This template uses phases and milestones"
                            : "This template uses the default process  "}
                        </label>
                      </Row>
                      <Row className="pt-3">
                        <br />
                        <Switch
                          checked={scenario.isSurvey}
                          onChange={(e) => {
                            setScenario({
                              ...scenario,
                              isSurvey: !scenario.isSurvey,
                            });
                          }}
                          className="mr-2 mb-2"
                          height={20}
                          width={40}
                        />

                        <label>
                          {scenario.isSurvey
                            ? "Survey Template"
                            : "Regular Decision Template"}
                        </label>
                      </Row>
                      <Row className="pt-3">
                        <div className="form-group">
                          <label>Parent Criteria</label>
                          <CustomInput
                            type="select"
                            className="form-control"
                            onChange={(e) =>
                              setScenario({
                                ...scenario,
                                parentID: e.target.value,
                              })
                            }
                            value={scenario.parentID}
                          >
                            <option value={0}>Select Parent</option>
                            {partnerObjectives.map((u, idx) => (
                              <option key={idx} value={u.partnerObjectiveID}>
                                {u.partnerObjectiveName}
                              </option>
                            ))}
                          </CustomInput>
                        </div>
                      </Row>

                      <Row className="pt-3">
                        <div className="form-group">
                          <label>Pairwise Comparison Method</label>
                          <CustomInput
                            type="select"
                            className="form-control"
                            onChange={(e) =>
                              setScenario({
                                ...scenario,
                                pwcMethod: e.target.value,
                              })
                            }
                            value={scenario.pwcMethod}
                          >
                            <option value="">Not set</option>
                            <option value="Full">
                              Perform all comparisons
                            </option>
                            <option value="Predictive">
                              Perform the minimum # of comparisons
                            </option>
                            <option value="Hybrid">
                              Augment the predictive method with additional
                              judgments
                            </option>
                          </CustomInput>
                        </div>
                      </Row>

                      {scenario?.isSurvey == true && (
                        <Row>
                          <Col>
                            <Button
                              color="primary"
                              type="button"
                              style={{ width: "160px" }}
                              onClick={getTemplateSetupReport}
                              disabled={isTemplateSetupReportLoading}
                            >
                              Template Setup Report
                            </Button>
                          </Col>
                        </Row>
                      )}
                    </Col>
                  </Row>
                  <div className="pull-right" style={{ marginTop: "20px" }}>
                    <Button
                      color="primary"
                      type="submit"
                      style={{ marginRight: ".25rem" }}
                    >
                      Save Template
                    </Button>
                    {scenario.partnerScenarioID > 0 && (
                      <Button color="danger" onClick={() => removeTemplate()}>
                        Remove Template
                      </Button>
                    )}
                    <Button
                      color="link"
                      className="pull-right"
                      onClick={() => props.history.goBack()}
                    >
                      Cancel
                    </Button>
                  </div>
                </AvForm>
              </CardBody>
            </Card>
            <div className="notes">
              <b>Notes:</b>
              <br />
              <b>Cost:</b> If this decision template will include the cost of
              the alternatives, describe how the cost field should be expressed
              in the template. It could simply be “Cost”. Other examples
              include: "Annual Salary", “Monthly Rent", etc.). This will enable
              users of the template to consider cost consistently. If the
              decision template doesn’t involve alternatives with a cost
              associated with them, leave this blank.
              <br />
              <b>Settings:</b> The settings above modify how the decision makers
              can interact with the template. Public templates are only for
              enterprise users and that setting must be updated by Definitive
              Choice.
              <br />
              <b>
                Once you save the basic template settings scroll down to add
                criteria, data-items and alternatives.
              </b>
            </div>
          </Col>
        </Row>
      )}

      <Row style={{ marginTop: "30px" }}>
        <Col md="12">
          <div style={{ width: "100%" }}>
            <div
              style={{
                width: tabWidth,
                display: "inline-block",
                textAlign: "center",
                padding: 10,
                color: activeTab == 1 ? colors.WHITE : colors.DODGER_BLUE,
                fontSize: 16,
                fontWeight: "bold",
                cursor: "pointer",
                backgroundColor:
                  activeTab == 1 ? colors.DODGER_BLUE : "transparent",
                border: "2px solid #4658ba",
                borderLeft: "1px",
                borderRight: "1px",
                borderTop: "0px",
              }}
              onClick={() => {
                setActiveTab(1);
              }}
            >
              Criteria and Alternatives
            </div>
            {showApiTab && (
              <div
                style={{
                  width: tabWidth,
                  display: "inline-block",
                  textAlign: "center",
                  padding: 10,
                  color: activeTab == 2 ? colors.WHITE : colors.DODGER_BLUE,
                  fontSize: 16,
                  fontWeight: "bold",
                  cursor: "pointer",
                  backgroundColor:
                    activeTab == 2 ? colors.DODGER_BLUE : "transparent",
                  border: "2px solid #4658ba",
                  borderLeft: "1px",
                  borderRight: "1px",
                  borderTop: "0px",
                }}
                onClick={() => {
                  setActiveTab(2);
                }}
              >
                API
              </div>
            )}
            {showPhasesTab && (
              <div
                style={{
                  width: tabWidth,
                  display: "inline-block",
                  textAlign: "center",
                  padding: 10,
                  color: activeTab == 3 ? colors.WHITE : colors.DODGER_BLUE,
                  fontSize: 16,
                  fontWeight: "bold",
                  cursor: "pointer",
                  backgroundColor:
                    activeTab == 3 ? colors.DODGER_BLUE : "transparent",
                  border: "2px solid #4658ba",
                  borderLeft: "1px",
                  borderRight: "1px",
                  borderTop: "0px",
                }}
                onClick={() => {
                  setActiveTab(3);
                }}
              >
                Phases and Milestones
              </div>
            )}
          </div>
        </Col>
      </Row>

      {scenario.partnerScenarioID > 0 && (
        <Fragment>
          {activeTab == 1 && (
            <Row style={{ marginTop: "30px" }}>
              <Col md="6">
                <Card className="main-card mb-3">
                  <CardBody>
                    <GeneralGrid
                      colWidth={12}
                      title={`Suggested ${
                        scenario.ahpOnly ? "Alternatives" : "Criteria"
                      }`}
                      keyField="partnerObjectiveID"
                      dataSource={objectives}
                      columns={objectiveColumns}
                      defaultSortedColumn="partnerObjectiveName"
                      showAddButton={true}
                      buttonText={`Add ${
                        scenario.ahpOnly ? "Alternative" : "Criteria"
                      }`}
                      onAdd={() => {
                        goToCriteria(-1);
                      }}
                    />
                  </CardBody>
                </Card>
              </Col>

              {(scenario.useIncludedAlternatives || scenario.useAltAPI) && (
                <Col md="6">
                  <Card className="main-card mb-3">
                    <CardBody>
                      <GeneralGrid
                        colWidth={12}
                        title="Alternative Data Items"
                        keyField="partnerMetricID"
                        dataSource={metrics}
                        columns={metricColumns}
                        defaultSortedColumn="partnerMetricName"
                        showAddButton={true}
                        buttonText={"Add Data Items"}
                        onAdd={() => goToMetric(-1)}
                      />
                    </CardBody>
                  </Card>
                </Col>
              )}
            </Row>
          )}

          {scenario.usePhases && activeTab == 3 && (
            <Row style={{ marginTop: "30px" }}>
              <Col md="6">
                <PhasesCard
                  phases={phases}
                  partnerScenarioId={partnerScenarioId}
                  reloadList={loadPhases}
                  onItemDeteled={loadPhasesAndMilestones}
                />
              </Col>

              <Col md="6">
                <MilestonesCard
                  milestones={milestones}
                  phases={phases}
                  reloadList={loadMilestones}
                />
              </Col>

              <Col md="6">
                <FieldsCard milestones={milestones} />
              </Col>
            </Row>
          )}

          {scenario.useAltAPI && activeTab == 2 && (
            <Row style={{ marginTop: "30px" }}>
              <Col md="12">
                <Card className="main-card mb-3">
                  <CardHeader>External API Configuration</CardHeader>
                  <CardBody>
                    <Row>
                      <Col md="12">
                        <AvForm onValidSubmit={testAPI}>
                          <div className="form-group">
                            <label>API Key Type</label>
                            <CustomInput
                              type="select"
                              id="akt"
                              name="apikeytype"
                              className="form-control"
                              onChange={(e) =>
                                setScenario({
                                  ...scenario,
                                  altAPIKeyType: e.target.value,
                                })
                              }
                              value={scenario.altAPIKeyType || "url"}
                            >
                              {["url", "auth header"].map((x) => (
                                <option key={x} value={x}>
                                  {x}
                                </option>
                              ))}
                            </CustomInput>
                          </div>

                          {scenario.altAPIKeyType === "auth header" && (
                            <AvField
                              name="altAPIKeyName"
                              label="API Key Name *"
                              value={scenario.altAPIKeyName}
                              onChange={(e) =>
                                setScenario({
                                  ...scenario,
                                  altAPIKeyName: e.target.value,
                                })
                              }
                              placeholder="Enter..."
                              required
                            />
                          )}

                          <AvField
                            name="altAPIKey"
                            label="API Key *"
                            value={scenario.altAPIKey}
                            onChange={(e) =>
                              setScenario({
                                ...scenario,
                                altAPIKey: e.target.value,
                              })
                            }
                            placeholder="Enter..."
                            required
                          />

                          <AvField
                            name="altAPISearchTemplate"
                            label="API Search Template *"
                            value={scenario.altAPISearchTemplate}
                            type="textarea"
                            style={{ height: "100px" }}
                            onChange={(e) =>
                              setScenario({
                                ...scenario,
                                altAPISearchTemplate: e.target.value,
                              })
                            }
                            placeholder="Enter..."
                            required
                          />

                          <AvField
                            name="altAPINameField"
                            label="API Alternative Name Node *"
                            value={scenario.altAPINameField}
                            onChange={(e) =>
                              setScenario({
                                ...scenario,
                                altAPINameField: e.target.value,
                              })
                            }
                            placeholder="Enter..."
                            required
                          />

                          <AvField
                            name="altAPIDescriptionField"
                            label="API Alternative Description Node"
                            value={scenario.altAPIDescriptionField}
                            onChange={(e) =>
                              setScenario({
                                ...scenario,
                                altAPIDescriptionField: e.target.value,
                              })
                            }
                            placeholder="Enter..."
                          />

                          <AvField
                            name="altAPICostField"
                            label="API Alternative Cost Node"
                            value={scenario.altAPICostField}
                            onChange={(e) =>
                              setScenario({
                                ...scenario,
                                altAPICostField: e.target.value,
                              })
                            }
                            placeholder="Enter..."
                          />

                          <div
                            className="pull-right"
                            style={{ marginTop: "20px" }}
                          >
                            <Button
                              color="primary"
                              type="submit"
                              style={{ marginRight: ".25rem" }}
                            >
                              Test
                            </Button>
                          </div>
                        </AvForm>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}

          {scenario.useIncludedAlternatives && activeTab == 1 && (
            <Row style={{ marginTop: "30px" }}>
              <Col md="12">
                <Card className="main-card mb-3">
                  <CardBody>
                    <GeneralGrid
                      colWidth={12}
                      title="Decision Alternatives"
                      keyField="partnerAlternativeID"
                      dataSource={alternatives}
                      columns={alternativeColumns}
                      defaultSortedColumn="partnerAlternativeName"
                      showAddButton={true}
                      buttonText={"Add Alternative"}
                      onAdd={() => goToAlternative(-1)}
                    />
                    <Col md="12">
                      <input
                        type="file"
                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        ref={hiddenFileInput}
                        onChange={handleInputFileChange}
                        style={{ display: "none" }}
                      />
                      <Button
                        color="primary"
                        style={{ marginTop: ".25rem" }}
                        onClick={handleUploadAlternativesClick}
                      >
                        Upload Alternatives Template
                      </Button>
                      <br />
                      <a
                        href="#"
                        style={{ marginLeft: ".25rem" }}
                        onClick={downloadPartnerAlternativeExcelTemplate}
                      >
                        Download Partner Alternative Template
                      </a>
                    </Col>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}
        </Fragment>
      )}

      <Modal
        size="lg"
        isOpen={isAddUserModalVisible}
        toggle={() => toggleAddUserModal()}
        backdrop="static"
      >
        <ModalHeader toggle={() => toggleAddUserModal()}>Add User</ModalHeader>

        <ModalBody>
          <Row>
            <Col md="12">
              {user != null && (
                <AvForm onSubmit={handleUserSubmit}>
                  <AvField
                    name="first"
                    label="First Name *"
                    value={user.firstName}
                    onChange={(e) =>
                      setUser({ ...user, firstName: e.target.value })
                    }
                    placeholder="Enter..."
                    required
                  />
                  <AvField
                    name="lastName"
                    label="Last Name *"
                    value={user.lastName}
                    onChange={(e) =>
                      setUser({ ...user, lastName: e.target.value })
                    }
                    placeholder="Enter..."
                    required
                  />
                  <AvField
                    name="email"
                    label="Email *"
                    value={user.email}
                    onChange={(e) =>
                      setUser({ ...user, email: e.target.value })
                    }
                    placeholder="Enter..."
                    required
                  />
                  <CustomInput
                    type="checkbox"
                    id={"pid"}
                    label={"All Templates"}
                    checked={user.allTemplates}
                    onChange={(e) => {
                      setUser({ ...user, allTemplates: !user.allTemplates });
                    }}
                  />
                  <Button
                    color="link"
                    className="pull-right"
                    onClick={() => toggleAddUserModal()}
                  >
                    Cancel
                  </Button>
                  <Button color="primary" type="submit" className="pull-right">
                    Save
                  </Button>
                </AvForm>
              )}
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <Card className="main-card mb-3">
                <CardBody>
                  <Row>
                    <Col md="6">
                      <h5>Templates</h5>
                    </Col>
                  </Row>

                  {partnerScenarios.length > 0 && (
                    <Table responsive striped>
                      <thead>
                        <tr>
                          <th width="15%">Selected</th>
                          <th>Name</th>
                        </tr>
                      </thead>
                      <tbody>
                        {partnerScenarios.map((x) => {
                          return (
                            <tr key={x.partnerScenarioID}>
                              <td>
                                <CustomInput
                                  type="checkbox"
                                  id={`vv-${x.partnerScenarioID}`}
                                  checked={x.isSelected}
                                  onChange={(e) => {
                                    changePartnerScenarioSelection(x);
                                  }}
                                />
                              </td>
                              <td>{x.partnerScenarioName}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row style={{ marginTop: "30px" }}>
            <Col md="12">
              <Button color="link" onClick={() => toggleAddUserModal()}>
                Cancel
              </Button>
            </Col>
          </Row>
        </ModalBody>
      </Modal>

      <MetricSettings
        showModal={isMetricModalOpen}
        toggleModal={toggleMetricModal}
        partnerMetricId={selectedPartnerMetricId}
        partnerScenarioId={partnerScenarioId}
        reloadList={loadMetrics}
        useAltAPI={scenario.useAltAPI}
      />

      <CriteriaSettings
        showMainModal={isCritModalOpen}
        toggleMainModal={toggleCriteriaModal}
        partnerObjectiveId={selectedPartnerObjectiveId}
        partnerScenarioId={partnerScenarioId}
        partnerScenario={scenario}
        reloadList={loadObjectives}
      />

      <AlternativeSettings
        showMainModal={isAltModalOpen}
        toggleMainModal={toggleAlternativeModal}
        partnerAlternativeId={selectedPartnerAlternativeId}
        partnerScenarioId={partnerScenarioId}
        reloadList={loadAlternatives}
      />

      <AlternativePreviewModal
        showMainModal={isAltPreviewModalOpen}
        toggleMainModal={toggleAltPreviewModal}
        partnerAlternativeId={selectedPartnerAlternativeId}
        partnerScenarioId={partnerScenarioId}
      />
    </Fragment>
  );
};

export default DecisionTemplateSettings;
